<template>
    <div class="com-codics-hbb-order-admin-goods-body">
        <div class="com-codics-hbb-order-admin-goods-bar-content">
            <el-cascader class="com-codics-hbb-order-admin-goods-bar-pick" v-model="goodsType" placeholder="请选择分类" filterable
                :options="typeOptions" :props="{ checkStrictly: true }" clearable
                @change="handleTypeChange"></el-cascader>
            <el-cascader class="com-codics-hbb-order-admin-goods-bar-pick" v-model="goodsBrand" placeholder="请选择品牌" filterable
                :options="brandOptions" :props="{ checkStrictly: true }" clearable
                @change="handleTypeChange"></el-cascader>
            <el-select v-model="goodsTag" multiple collapse-tags style="float:left;margin-right:15px;"
                placeholder="请选择标签" filterable clearable @change="listGoodssFuc">
                <el-option v-for="item in tagsOptions" :key="item" :label="item" :value="item">
                </el-option>
            </el-select>
            <el-input class="com-codics-hbb-order-admin-goods-bar-input" v-model="searchTxt" placeholder="请输入商品信息..."
                clearable @input="searchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;" @click.native="searchGoodss">&#xe86e;
            </MyButton>
            <MyButton style="float: right;" @click.native="jumpToPage('添加商品', {}, {})">&#xe632; 添加商品</MyButton>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的商品数据（包括销售参数）吗？" @confirm="deleteGoodssFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference">&#xe850;</MyButton>
            </el-popconfirm>
            <MyButton style="float: right;margin-right: 15px;padding:0 15px;">&#xe854;</MyButton>
        </div>
        <div class="com-codics-hbb-order-admin-goods-bar-content com-codics-hbb-order-admin-goods-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="searchTxt == '' ? tableData : searchData" style="width: 100%;transition: .3s;"
                @selection-change="handleSelectionChange">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="com-codics-hbb-order-admin-goods-item-box" v-for="(item, index) in props.row.info"
                            :key="index">
                            <div class="com-codics-hbb-order-admin-goods-item-card">
                                <div class="com-codics-hbb-order-admin-goods-item-card-line">
                                    <el-image class="com-codics-hbb-order-admin-goods-item-card-line-img"
                                        :src="'https://cdn.bosscaigou.com/' + item.img"></el-image>
                                    <div class="com-codics-hbb-order-admin-goods-item-card-line-text"
                                        style="padding-right: 35px;" :title="item.title">
                                        {{ item.title }}
                                        <el-tag style="position:absolute;margin:auto;top: 0;bottom: 0;right: 0;"
                                            size="mini" :type="item.state == 0 ? 'success' : 'danger'">{{ item.state ==
                                                0 ? '上架' : '下架'
                                            }}</el-tag>
                                    </div>
                                    <div
                                        class="com-codics-hbb-order-admin-goods-item-card-line-text com-codics-hbb-order-admin-goods-item-card-line-text2">
                                        成本：￥{{ item.op }}/{{ (item.unit == null || item.unit == '') ? '个' :
                                            item.unit }}&nbsp;&nbsp;&nbsp;<span style="color: red;">库存：{{ item.inventory }}
                                            ({{ (item.unit == null || item.unit == '') ? '个' :
                                                item.unit }})</span>
                                    </div>
                                    <div
                                        class="com-codics-hbb-order-admin-goods-item-card-line-text com-codics-hbb-order-admin-goods-item-card-line-text2">
                                        售价：￥{{ item.np }}/{{ (item.unit == null || item.unit == '') ? '个' : item.unit }}
                                    </div>
                                </div>
                                <div class="com-codics-hbb-order-admin-goods-item-card-line2">
                                    <span
                                        style="float:left;width:50%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                                        :title="item.remark">备注:{{ item.remark }}</span>
                                    <el-popover popper-class="com-codics-ui-sidebar-menu-item-popper" placement="top"
                                        width="160" trigger="hover">
                                        <div class="com-codics-ui-sidebar-menu-item-child"
                                            v-for="(item2, index2) in ['编辑', '补库存', '删除']" :key="index2" v-html="item2"
                                            @click="handleMenuClick(item2, item)"></div>
                                        <div class="iconfont com-codics-hbb-order-admin-goods-item-card-more-btn"
                                            slot="reference">
                                            &#xe866;
                                        </div>
                                    </el-popover>
                                    <span style="float:right;width:calc(50% - 35px);text-align:right;"
                                        :title="initTime(item.ctime)">{{ initTime(item.ctime)
                                        }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="com-codics-hbb-order-admin-goods-item-box" style="width:160px;">
                            <div @click="handleGoodsInfoAdd(props.row)"
                                class="com-codics-hbb-order-admin-goods-item-card com-codics-hbb-order-admin-goods-item-card2">
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="50">
                </el-table-column>
                <el-table-column prop="id" label="ID" width="80">
                </el-table-column>
                <el-table-column prop="title" label="商品名称" width="110">
                </el-table-column>
                <el-table-column prop="detail" label="商品介绍" width="150">
                </el-table-column>
                <el-table-column prop="himg" label="商品封面" width="150">
                    <el-carousel slot-scope="scope" height="70px" width="150px" indicator-position="none">
                        <el-carousel-item v-for="(item, index) in scope.row.himg.split(',')" :key="index">
                            <el-image style="width: 100%; height: 100%" :src="'https://cdn.bosscaigou.com/' + item"
                                fit="cover"
                                :preview-src-list="scope.row.himg.split(',').map(item2 => 'https://cdn.bosscaigou.com/' + item2)"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </el-table-column>
                <el-table-column prop="dimg" label="详情图片" width="150">
                    <el-carousel slot-scope="scope" height="70px" width="150px" indicator-position="none">
                        <el-carousel-item v-for="(item, index) in scope.row.dimg.split(',')" :key="index">
                            <el-image style="width: 100%; height: 100%" :src="'https://cdn.bosscaigou.com/' + item"
                                fit="cover"
                                :preview-src-list="scope.row.dimg.split(',').map(item2 => 'https://cdn.bosscaigou.com/' + item2)"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </el-table-column>
                <el-table-column prop="video" label="商品视频" width="90">
                    <template slot-scope="scope">
                        <el-button v-show="scope.row.video != ''" type="primary" size="mini"
                            @click="playVideo(scope.row.video)">播放</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="tip" label="购买须知" width="110">
                </el-table-column>
                <el-table-column prop="origin" label="产地" width="110">
                </el-table-column>
                <el-table-column prop="type" label="商品分类" width="110">
                    <template slot-scope="scope">
                        <el-tag disable-transitions size="mini">{{
                            scope.row?.type }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" width="70"
                    :filters="[{ text: '上架', value: 0 }, { text: '下架', value: 1 }]" :filter-method="stateFilter"
                    filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state == 0 ? 'success' : 'danger'" disable-transitions size="mini">{{
                            scope.row.state == 0 ? '上架'
                                : '下架' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="ts" label="包邮" width="70"
                    :filters="[{ text: '包邮', value: 0 }, { text: '不包邮', value: 1 }]" :filter-method="tsFilter"
                    filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.ts == 0 ? 'success' : 'danger'" disable-transitions size="mini">{{
                            scope.row.ts == 0 ? '包邮'
                                : '不包邮' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="tt" label="物流方式" width="80">
                    <template slot-scope="scope">
                        {{ wuliuType[scope.row.tt] }}
                    </template>
                </el-table-column>
                <el-table-column prop="ctime" label="创建时间" width="180">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.ctime) }}
                    </template>
                </el-table-column>
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要删除当前商品数据（包括销售参数）吗？" @confirm="deleteGoodssFuc([scope.row.id])">
                            <MyButton v-show="scope.row.member != 0" size="small" type="danger" style="float: right;"
                                slot="reference">删除</MyButton>
                        </el-popconfirm>
                        <MyButton size="small" style="float: right;margin-right: 10px;"
                            @click.native="goodsUpdateForm = { ...goodsUpdateForm, ...scope.row }; goodsUpdateForm.himgList = scope.row.himg === '' ? [] : scope.row.himg.split(','); goodsUpdateForm.dimgList = scope.row.dimg === '' ? [] : scope.row.dimg.split(','); goodsUpdateForm.videoList = scope.row.video === '' ? [] : scope.row.video.split(','); goodsDialog = true; goodsUpdateForm.type = []; goodsUpdateForm.brand = []; findNodeById(typeOptions, scope.row.type, []); findNodeById2(brandOptions, scope.row.brand, []);"
                            slot="reference">编辑
                        </MyButton>
                        <MyButton size="small" style="float: right;margin-right: 10px;" slot="reference">详情
                        </MyButton>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[10, 20, 30, 40, 100]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
        <el-dialog title="修改销售参数" :visible.sync="goodsInfoDialog">
            <el-form ref="form" :model="updateForm" label-width="110px">
                <el-form-item label="销售参数封面">
                    <MyUpload v-model="imgList" multiple :limit="1"></MyUpload>
                </el-form-item>
                <el-form-item label="销售参数名称">
                    <el-input v-model="updateForm.title" style="width:230px;"></el-input>
                </el-form-item>
                <el-form-item label="销售参数原价">
                    <el-input-number v-model="updateForm.op" :precision="2" :step="0.1" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="销售参数现价">
                    <el-input-number v-model="updateForm.np" :precision="2" :step="0.1" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="销售参数单位">
                    <el-input v-model="updateForm.unit" style="width:230px;"></el-input>
                </el-form-item>
                <el-form-item label="销售参数备注">
                    <el-input v-model="updateForm.remark" style="width:230px;"></el-input>
                </el-form-item>
                <el-form-item label="销售参数状态">
                    <el-select v-model="updateForm.state" placeholder="请选择参数状态" style="width:230px;">
                        <el-option v-for="item in [{ value: 0, label: '上架' }, { value: 1, label: '下架' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="goodsInfoDialog = false;">取 消</el-button>
                <el-button type="primary" @click="updateGoodsInfoFuc">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加销售参数" :visible.sync="addInfoDialog">
            <el-form ref="form" :model="infoAddForm" label-width="110px">
                <el-form-item label="销售参数封面">
                    <MyUpload v-model="imgList" multiple :limit="1"></MyUpload>
                </el-form-item>
                <el-form-item label="销售参数名称">
                    <el-input v-model="infoAddForm.title" style="width:230px;"></el-input>
                </el-form-item>
                <el-form-item label="销售参数原价">
                    <el-input-number v-model="infoAddForm.op" :precision="2" :step="0.1" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="销售参数现价">
                    <el-input-number v-model="infoAddForm.np" :precision="2" :step="0.1" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="销售参数库存">
                    <el-input-number v-model="infoAddForm.inventory" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="销售参数单位">
                    <el-input v-model="infoAddForm.unit" style="width:230px;"></el-input>
                </el-form-item>
                <el-form-item label="销售参数备注">
                    <el-input v-model="infoAddForm.remark" style="width:230px;"></el-input>
                </el-form-item>
                <el-form-item label="销售参数状态">
                    <el-select v-model="infoAddForm.state" placeholder="请选择参数状态" style="width:230px;">
                        <el-option v-for="item in [{ value: 0, label: '上架' }, { value: 1, label: '下架' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addInfoDialog = false;">取 消</el-button>
                <el-button type="primary" @click="addGoodsInfoFuc">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑商品" :visible.sync="goodsDialog" width="80%">
            <el-form :model="goodsUpdateForm">
                <el-form-item label="商品名称" :label-width="formLabelWidth" required>
                    <el-input v-model="goodsUpdateForm.title" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="商品介绍" :label-width="formLabelWidth" required>
                    <el-input type="textarea" v-model="goodsUpdateForm.detail" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="商品封面" :label-width="formLabelWidth" required>
                    <MyUpload v-model="goodsUpdateForm.himgList" multiple :limit="10"></MyUpload>
                </el-form-item>
                <el-form-item label="图片介绍" :label-width="formLabelWidth">
                    <MyUpload v-model="goodsUpdateForm.dimgList" multiple :limit="30"></MyUpload>
                </el-form-item>
                <el-form-item label="商品视频" :label-width="formLabelWidth">
                    <MyUpload v-model="goodsUpdateForm.videoList" accept="video/*" multiple :limit="1"></MyUpload>
                </el-form-item>
                <el-form-item label="购买须知" :label-width="formLabelWidth">
                    <el-input v-model="goodsUpdateForm.tip" style="width:380px;"></el-input>
                </el-form-item>
                <el-form-item label="商品分类" required :label-width="formLabelWidth">
                    <el-cascader v-model="goodsUpdateForm.type" style="width:380px;float:left;" placeholder="请选择商品分类"
                        :options="typeOptions" :props="{ checkStrictly: true }" clearable></el-cascader>
                    <MyButton style="margin-left:15px;" @click.native="jumpToPage('分类管理', {}, {})">没有？去创建</MyButton>
                </el-form-item>
                <el-form-item label="商品品牌" required :label-width="formLabelWidth">
                    <el-cascader v-model="goodsUpdateForm.brand" style="width:380px;float:left;" placeholder="请选择商品品牌"
                        :options="brandOptions" :props="{ checkStrictly: true }" clearable></el-cascader>
                    <MyButton style="margin-left:15px;" @click.native="jumpToPage('品牌管理', {}, {})">没有？去创建</MyButton>
                </el-form-item>
                <el-form-item label="商品标签" required :label-width="formLabelWidth">
                    <el-tag v-for="(tag, index2) in goodsUpdateForm.tags" :key="index2" closable
                        :disable-transitions="false" style="margin-right: 10px;"
                        :type="['', 'success', 'warning', 'danger'][index2 % 4]" @close="handleTagClose(tag)">
                        {{ tag.tag }}
                    </el-tag>
                    <el-input style="width:90px !important;margin-right:10px;" v-if="inputTagVisible"
                        v-model="inputTagValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm">
                    </el-input>
                    <el-button style="width:90px !important;margin-right:10px;" v-else class="button-new-tag"
                        size="small" @click="showInput">+ 新建标签</el-button>
                </el-form-item>
                <el-form-item label="商品产地" required :label-width="formLabelWidth">
                    <el-cascader style="width:380px;" :props="{ checkStrictly: true }" size="large" filterable
                        :options="areaOptions" v-model="goodsUpdateForm.origin" clearable>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="商品状态" required :label-width="formLabelWidth">
                    <el-select v-model="goodsUpdateForm.state" placeholder="请选择商品状态" style="width:380px;">
                        <el-option v-for="item in [{ value: 0, label: '上架' }, { value: 1, label: '下架' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详情链接" :label-width="formLabelWidth">
                    <el-input style="position:relative;float:left;width:380px;" v-model="goodsUpdateForm.url"
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="是否包邮" required :label-width="formLabelWidth">
                    <el-select v-model="goodsUpdateForm.ts" placeholder="请选择是否包邮" style="width:380px;">
                        <el-option v-for="item in [{ value: 0, label: '包邮' }, { value: 1, label: '不包邮' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="margin-left: 15px;" v-show="goodsUpdateForm.ts == 1"><span class="iconfont"
                            style="color:red;">&#xe85c;</span>不包邮时需要您在”邮费时效信息“栏目内进行说明！</span>
                </el-form-item>
                <el-form-item label="物流类型" required :label-width="formLabelWidth">
                    <el-select v-model="goodsUpdateForm.tt" placeholder="请选择物流类型" style="width:380px;">
                        <el-option v-for="item in wuliuData" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="margin-left: 15px;" v-show="goodsUpdateForm.tt == 'qitafangshi'"><span class="iconfont"
                            style="color:red;">&#xe85c;</span>当前物流方式需要您在”邮费时效信息“栏目内进行说明！</span>
                </el-form-item>
                <el-form-item label="邮费时效信息" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="goodsUpdateForm.ttime" style="width:380px;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateGoodsFuc">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="补充库存" :visible.sync="kucunVisible">
            <el-form>
                <el-form-item label="补充数量" :label-width="formLabelWidth">
                    <el-input-number v-model="kucunNum" label="请选择要补充的库存数量" :precision="0"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="storeGoodsInfoFuc">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import MyUpload from '@/components/MyUpload';
import { addGoods, deleteGoods, updateGoods, listGoods, listGoodsBrand, listGoodsType, listTags, addGoodsInfo, updateGoodsInfo, deleteGoodsInfo, storeGoodsInfo, updateGoodsType } from '@/api';
import { jumpTo } from '@/utils/myutils';
import areaData from '../../../../public/data/data2.json';
export default {
    data() {
        return {
            inputTagValue: '',
            inputTagVisible: false,
            nowId: null,
            kucunVisible: false,
            kucunNum: 0,
            formLabelWidth: '120px',
            goodsDialog: false,
            goodsUpdateForm: {
                himgList: [],
                dimgList: [],
                videoList: [],
                title: '',
                detail: '',
                himg: '',
                dimg: '',
                video: '',
                tip: '',
                type: [],
                brand: [],
                tags: [],
                origin: [],
                state: 0,
                url: '',
                tags: [

                ]
            },
            goodsInfoDialog: false,
            addInfoDialog: false,
            tableData: [],
            searchData: [],
            selectData: [],
            roleData: [],
            memsList: [],
            typeOptions: [],
            brandOptions: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 10,
            searchSize: 10,
            maxSize: 0,
            searchMax: 0,
            goodsType: [],
            goodsBrand: [],
            tagsOptions: [],
            areaOptions: areaData,
            goodsTag: [],
            wuliuType: {
                'shunfeng': '顺丰快递',
                'zhongtong': '中通快递',
                'yuantong': '圆通快递',
                'shentong': '申通快递',
                'jtexpress': '极兔快递',
                'yunda': '韵达快递',
                'jd': '京东快递',
                'ems': '邮政快递',
                'qitafangshi': '其他方式'
            },
            wuliuData: [
                {
                    value: 'shunfeng',
                    label: '顺丰快递'
                },
                {
                    value: 'zhongtong',
                    label: '中通快递'
                },
                {
                    value: 'yuantong',
                    label: '圆通快递'
                },
                {
                    value: 'shentong',
                    label: '申通快递'
                },
                {
                    value: 'jtexpress',
                    label: '极兔快递'
                },
                {
                    value: 'yunda',
                    label: '韵达快递'
                },
                {
                    value: 'jd',
                    label: '京东快递'
                },
                {
                    value: 'ems',
                    label: '邮政快递'
                },
                {
                    value: 'qitafangshi',
                    label: '其他方式'
                }
            ],
            imgList: [],
            infoAddForm: {
                img: '',
                title: '',
                op: 0,
                np: 0,
                pid: null,
                inventory: 0,
                unit: '',
                remark: '',
                state: 0
            },
            updateForm: {
                id: null,
            }
        }
    },
    components: {
        MyButton,
        MyUpload
    },
    mounted() {

        this.listGoodssFuc();

        this.listGoodsBrandFuc();

        this.listGoodsTypeFuc();

        this.listTagsFuc();

    },
    methods: {
        findNodeById(nodes, id, path) {
            for (let node of nodes) {
                path.push(node.value);
                if (node.value === id) {
                    this.goodsUpdateForm.type = path; // 找到对应的节点，将路径赋值给v-model
                    return;
                }
                if (node.children && node.children.length > 0) {
                    this.findNodeById(node.children, id, path.slice()); // 递归查找子节点
                }
                path.pop();
            }
            console.log(path);
        },
        findNodeById2(nodes, id, path) {
            for (let node of nodes) {
                path.push(node.value);
                if (node.value === id) {
                    this.goodsUpdateForm.brand = path; // 找到对应的节点，将路径赋值给v-model
                    return;
                }
                if (node.children && node.children.length > 0) {
                    this.findNodeById(node.children, id, path.slice()); // 递归查找子节点
                }
                path.pop();
            }
        },

        async updateGoodsFuc() {

            if (this.goodsUpdateForm.title == '') {

                this.$message({
                    showClose: true,
                    message: '请输入商品名称！',
                    type: 'warning'
                });

                return;

            }

            if (this.goodsUpdateForm.detail == '') {

                this.$message({
                    showClose: true,
                    message: '请输入商品介绍！',
                    type: 'warning'
                });

                return;

            }

            if (this.goodsUpdateForm.himgList.length == 0) {

                this.$message({
                    showClose: true,
                    message: '请上传商品封面！',
                    type: 'warning'
                });

                return;
            }

            if (this.goodsUpdateForm.type.length == 0 || this.goodsUpdateForm.type == null) {

                this.$message({
                    showClose: true,
                    message: '请选择商品分类！',
                    type: 'warning'
                });

                return;

            }

            if (this.goodsUpdateForm.brand.length == 0 || this.goodsUpdateForm.type == null) {

                this.$message({
                    showClose: true,
                    message: '请选择商品品牌！',
                    type: 'warning'
                });
                return;
            }

            if (this.goodsUpdateForm.origin == '') {

                this.$message({
                    showClose: true,
                    message: '请选择商品产地！',
                    type: 'warning'
                });

                return;
            }

            if (this.goodsUpdateForm.state == null) {

                this.$message({
                    showClose: true,
                    message: '请选择商品状态！',
                    type: 'warning'
                });

                return;
            }

            if (this.goodsUpdateForm.ts == null) {

                this.$message({
                    showClose: true,
                    message: '请选择是否包邮！',
                    type: 'warning'
                });

                return;
            }

            if (this.goodsUpdateForm.tt == null) {

                this.$message({
                    showClose: true,
                    message: '请选择物流类型！',
                    type: 'warning'
                });

                return;
            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            this.goodsUpdateForm.type = this.goodsUpdateForm.type[this.goodsUpdateForm.type.length - 1];

            this.goodsUpdateForm.brand = this.goodsUpdateForm.brand[this.goodsUpdateForm.brand.length - 1];



            const data = await updateGoods({ ...this.goodsUpdateForm, himg: this.goodsUpdateForm.himgList.join(','), dimg: this.goodsUpdateForm.dimgList.join(','), video: this.goodsUpdateForm.videoList.join(',') });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '数据修改成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleInputConfirm() {
            let inputValue = this.inputTagValue;
            this.addForm.tags = this.addForm.tags == null ? [] : this.addForm.tags;
            if (inputValue) {
                this.addForm.tags.push({
                    tag: inputValue
                });
            }
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        showInput() {
            this.inputTagVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleTagClose(tag) {

            this.goodsUpdateForm.tags.filter(item => item.id != tag.id);

        },
        async storeGoodsInfoFuc() {

            if (this.nowId === null) {

                this.$message({
                    showClose: true,
                    message: '请先选中要补充库存的数据！',
                    type: 'warning'
                });

                return true;

            }

            if (this.kucunNum === 0 || this.kucunNum == null) {

                this.$message({
                    showClose: true,
                    message: '请输入要补充的库存数量！',
                    type: 'warning'
                });

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await storeGoodsInfo({ id: this.nowId, count: this.kucunNum });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '数据修改成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteGoodsInfoFuc(t) {

            console.log(t)

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await deleteGoodsInfo({ 'ids': t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async updateGoodsInfoFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            if (this.imgList.length == 0) {

                this.$message.error('请先上传销售参数封面！');

                return;

            }

            if (this.updateForm.title == '') {

                this.$message.error('请输入销售参数名称！');

                return;

            }

            if (this.updateForm.unit == '') {

                this.$message.error('请输入销售参数单位！');

                return;

            }

            this.updateForm.img = this.imgList.join(',');

            const data = await updateGoodsInfo(this.updateForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '数据修改成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async addGoodsInfoFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            if (this.infoAddForm.pid == null) {

                this.$message.error('请选择商品！');

                return;

            }

            if (this.imgList.length == 0) {

                this.$message.error('请先上传销售参数封面！');

                return;

            }

            if (this.infoAddForm.title == '') {

                this.$message.error('请输入销售参数名称！');

                return;

            }

            if (this.infoAddForm.unit == '') {

                this.$message.error('请输入销售参数单位！');

                return;

            }

            this.infoAddForm.img = this.imgList.join(',');

            const data = await addGoodsInfo(this.infoAddForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '数据添加成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleGoodsInfoAdd(row) {
            this.imgList = [];
            this.infoAddForm.pid = row.id;
            this.addInfoDialog = true;
        },
        handleMenuClick(item, item2) {
            switch (item) {
                case '编辑':
                    this.goodsInfoDialog = true;
                    this.imgList = item2.img.split(',');
                    this.updateForm = { ...item2 };
                    break;
                case '补库存':
                    this.nowId = item2.id;
                    this.kucunVisible = true;
                    this.kucunNum = 0;
                    break;
                case '删除':
                    this.deleteGoodsInfoFuc([item2.id]);
                    break;
            }
        },
        async listTagsFuc() {
            const data = await listTags();
            if (data.code == 200) {
                this.tagsOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listGoodsBrandFuc() {
            const data = await listGoodsBrand();
            if (data.code == 200) {
                this.brandOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listGoodsTypeFuc() {
            const data = await listGoodsType();
            if (data.code == 200) {
                this.typeOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listGoodssFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listGoodssFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        addGoodsCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchGoodss() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listGoodssFuc();

        },
        async listGoodssFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listGoods({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                type: this.goodsType.length == 0 ? 0 : this.goodsType[this.goodsType.length - 1],
                brand: this.goodsBrand.length == 0 ? 0 : this.goodsBrand[this.goodsBrand.length - 1],
                tags: this.goodsTag
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteGoodssFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteGoods({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listGoodssFuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listGoodssFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        handleTypeChange() {
            this.listGoodssFuc();
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        tsFilter(v, r, c) {

            return r.ts === v;

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
    }
}
</script>

<style>
.com-codics-hbb-order-admin-goods-body {
    /* height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px; */
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

:root {
    --el-input-bg-color: #FFF;
    --el-input-l-color: #DCDFE6;
    --el-input-l-hover-color: #C0C4CC;
    --el-input-l-focus-color: #000;
    --el-table-bg-color: #FFF;
    --el-table-l-color: #EBEEF5;
    --el-table-bg-hover-color: #F5F7FA;
    --el-table-body-font-color: #606266;
    --el-table-page-bg-color: #FFF;
    --el-table-page-bg-active-color: #333;
    --el-table-page-font-color: #606266;
    --el-table-page-font-active-color: #FFF;
}

:root[data-theme="dark"] {
    --el-input-bg-color: #333;
    --el-input-l-color: #444;
    --el-input-l-hover-color: #555;
    --el-input-l-focus-color: #888;
    --el-table-bg-color: #333;
    --el-table-l-color: #444;
    --el-table-bg-hover-color: #555;
    --el-table-body-font-color: #999;
    --el-table-page-bg-color: #292B2C;
    --el-table-page-bg-active-color: #FFF;
    --el-table-page-font-color: #AAA;
    --el-table-page-font-active-color: #333;
}

.el-input__inner {
    background-color: var(--el-input-bg-color) !important;
    border-color: var(--el-input-l-color) !important;
}

.el-input__inner:hover {
    border-color: var(--el-input-l-hover-color) !important;
}

.el-input__inner:focus {
    border-color: var(--el-input-l-focus-color) !important;
}

.el-table th.el-table__cell {
    background-color: var(--el-table-bg-color) !important;
}

.el-table tr {
    background-color: var(--el-table-bg-color) !important;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--el-table-l-color) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: var(--el-table-bg-hover-color) !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: var(--el-table-l-color) !important;
}

.el-table {
    color: var(--el-table-body-font-color) !important;
}

.el-table,
.el-table__expanded-cell {
    background: var(--el-table-bg-color) !important;
}

.com-codics-hbb-order-admin-goods-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-goods-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-goods-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-hbb-order-admin-goods-item-box {
    height: 155px;
    width: 25%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    transition: .3s;
    display: flex;
}

.com-codics-hbb-order-admin-goods-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 8px;
    transition: .3s;
    background: #F9F9F9;
    border: 1px solid #DDD;
    cursor: pointer;
}

.com-codics-hbb-order-admin-goods-item-card-line {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-item-card-line::before {
    content: '';
    height: 1px;
    width: calc(100% - 20px);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    background: #EEE;
}

.com-codics-hbb-order-admin-goods-item-card-line-img {
    height: 80px;
    width: 80px;
    position: relative;
    float: left;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 8px;
}

.com-codics-hbb-order-admin-goods-item-card-line-text {
    height: 30px;
    width: calc(100% - 80px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding-left: 10px;
    transition: .3s;
    line-height: 30px;
    font-size: 11px;
    font-weight: bolder;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.com-codics-hbb-order-admin-goods-item-card-line-text .el-tag {
    font-size: 9px;
}

.com-codics-hbb-order-admin-goods-item-card-line-text2 {
    height: 25px;
    line-height: 25px;
    color: #999;
}

.com-codics-hbb-order-admin-goods-item-card-line2 {
    height: 35px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 35px;
    font-size: 11px;
    font-weight: bolder;
    color: #666;
    padding-left: 10px;
    user-select: none;
}

.com-codics-hbb-order-admin-goods-item-card-more-btn {
    height: 35px;
    width: 35px;
    position: relative;
    float: right;
    box-sizing: border-box;
    line-height: 35px;
    text-align: center;
    font-size: 11px;
    color: #333;
    cursor: pointer;
    user-select: none;
}

.com-codics-hbb-order-admin-goods-item-card2 {
    border: 1px dashed #666;
    border-radius: 8px;
    transition: .3s;
    background: transparent;
    cursor: pointer;
}

.com-codics-hbb-order-admin-goods-item-card2::before,
.com-codics-hbb-order-admin-goods-item-card2::after {
    content: '';
    height: 1px;
    width: 25px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: .3s;
    background: #666;
}

.com-codics-hbb-order-admin-goods-item-card2::after {
    transform: rotate(90deg);
}
</style>